module.exports = __webpack_public_path__ + "img/lucas-logos_transparent_no_text.faf6dd82.png";